'use strict';

const isString = require('lodash/isString');

module.exports = () => {
    return (string, pattern, replacement) => {
        if (!isString(string)) {
            return string;
        }

        if (string.length === 0) {
            return '';
        }

        if (!pattern || !replacement) {
            return string;
        }

        return string.replace(pattern, replacement);
    };
};



// WEBPACK FOOTER //
// ./widgets/filters/replace.js